import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserInfoModal } from 'components';
import { Link, useHistory } from 'react-router-dom';
import { logoutUserStart } from 'redux/user/user.actions';
import { EditOperatorModal } from 'components';
import { useModal } from 'hooks';
import useTranslation from 'hooks/useTranslation';
import routes from 'routes';

const mapState = (state) => ({
  profile: state.userData.profile,
  weeklyChosenOperator: state.operatorsData.weeklyChosenOperator,
});

const ProfileLinks = ({ handlePopoverOpen }) => {
  const { profile, weeklyChosenOperator } = useSelector(mapState);
  const [isUserInfoModalVisible, , hideUserInfoModal, showUserInfoModal] =
    useModal();

  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  const LINKS_OBJECT = [
    {
      id: 'upgrade',
      label: t('UPGRADE_PACKAGE'),
      route: routes.packageUpgrade,
    },
    {
      id: 'charge',
      label: t('CHARGE_CONVS'),
      route: routes.conversationsChagrge,
    },
    {
      id: 'bill',
      label: t('BILLS_LIST'),
      route: routes.bills,
    },
  ];

  const isWeeklyChosen =
    Object.keys(weeklyChosenOperator).length > 0 &&
    profile.userId === weeklyChosenOperator.id
      ? true
      : false;
  const handleLogout = (event) => {
    event.preventDefault();
    dispatch(logoutUserStart({ history }));
  };

  const renderUserInfoModalToggleBtn = (
    <>
      <a href='#/' onClick={showUserInfoModal}>
        {t('COMPLETE_INFO')}
      </a>
    </>
  );

  return (
    <>
      <div className='primary__menu__bottom__profile__menu__inner__seperator primary__menu__bottom__profile__menu__inner__extension'>
        {LINKS_OBJECT.map((item) => (
          <Link
            onClick={() => handlePopoverOpen(false)}
            key={item.id}
            to={item.route}
          >
            {item.label}
          </Link>
        ))}
      </div>
      <div
        onClick={() => handlePopoverOpen(false)}
        className='primary__menu__bottom__profile__menu__inner__seperator primary__menu__bottom__profile__menu__inner__account'
      >
        <EditOperatorModal
          operatorId={profile.userId}
          isWeeklyChosen={isWeeklyChosen}
          isProfile
        />
        {renderUserInfoModalToggleBtn}
        <UserInfoModal
          visible={isUserInfoModalVisible}
          handleClose={hideUserInfoModal}
          doAfterSuccessfullUpdate={hideUserInfoModal}
        />
      </div>
      <div className='primary__menu__bottom__profile__menu__inner__seperator primary__menu__bottom__profile__menu__inner__exit'>
        <a href='#/' onClick={handleLogout}>
          {t('EXIT')}
        </a>
      </div>
    </>
  );
};

export default ProfileLinks;
